import { useTranslation } from 'react-i18next';

const Careers = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-12 py-20">
        <h1 className="font-serif text-4xl md:text-5xl font-light tracking-wide text-center mb-4 text-gray-900">
          Kariyer
        </h1>
        <p className="text-center text-gray-500 font-light tracking-wide mb-16 uppercase text-xs">
          Mashow Ailesine Katılın
        </p>

        <div className="prose prose-lg max-w-none text-gray-600 font-light leading-relaxed space-y-12">
          {/* Section 1: Who We Are */}
          <section className="space-y-4">
            <h2 className="font-serif text-2xl md:text-3xl font-light text-gray-900 tracking-wide border-b border-gray-100 pb-2">
              Biz Kimiz?
            </h2>
            <p>
              Mashow, lüks takı ve mücevherat sektöründe modern tasarımı, kusursuz işçiliği ve müşteri memnuniyeti odaklı hizmet anlayışını bir araya getiren dinamik bir markadır. Her bir mücevheri zamansız birer sanat eserine dönüştürürken, en büyük gücümüzü tutkuyla çalışan ekibimizden alıyoruz.
            </p>
          </section>

          {/* Section 2: Culture */}
          <section className="space-y-4">
            <h2 className="font-serif text-2xl md:text-3xl font-light text-gray-900 tracking-wide border-b border-gray-100 pb-2">
              Çalışma Kültürümüz
            </h2>
            <p>
              Mashow'da yaratıcılığın, sürekli gelişimin ve ekip çalışmasının önemine inanıyoruz. Her bir çalışma arkadaşımızın fikirlerine değer veriyor, potansiyellerini en üst düzeye çıkarabilecekleri, açık ve şeffaf bir çalışma ortamı sunuyoruz. Sanat, zanaat ve teknolojinin birleştiği bu benzersiz yolculukta bizimle birlikte yürümek isteyen yaratıcı beyinleri arıyoruz.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-4">
              <div className="bg-gray-50 p-6 rounded border border-gray-100">
                <h3 className="font-serif text-lg text-gray-900 mb-2 font-normal">Yaratıcılık & İnovasyon</h3>
                <p className="text-sm text-gray-500">Alışılmışın dışında düşünerek özgün tasarımlar üretmeyi destekliyoruz.</p>
              </div>
              <div className="bg-gray-50 p-6 rounded border border-gray-100">
                <h3 className="font-serif text-lg text-gray-900 mb-2 font-normal">Sürekli Gelişim</h3>
                <p className="text-sm text-gray-500">Eğitimler ve mentorluk programları ile mesleki becerilerinizi geliştirebilirsiniz.</p>
              </div>
              <div className="bg-gray-50 p-6 rounded border border-gray-100">
                <h3 className="font-serif text-lg text-gray-900 mb-2 font-normal">Takım Ruhu</h3>
                <p className="text-sm text-gray-500">Karşılıklı saygı ve yardımlaşmaya dayanan güçlü bir sinerjiyle çalışıyoruz.</p>
              </div>
            </div>
          </section>

          {/* Section 3: Open Positions */}
          <section className="space-y-4">
            <h2 className="font-serif text-2xl md:text-3xl font-light text-gray-900 tracking-wide border-b border-gray-100 pb-2">
              Açık Pozisyonlar
            </h2>
            <div className="border border-gray-100 rounded divide-y divide-gray-100">
              <div className="p-6 hover:bg-gray-50 transition">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                  <div>
                    <h3 className="font-serif text-xl text-gray-900 mb-1 font-normal">Genel Başvuru</h3>
                    <p className="text-xs text-gray-500 uppercase tracking-wider">Tüm Departmanlar • İstanbul, Merkez</p>
                  </div>
                  <span className="inline-block text-xs font-semibold uppercase tracking-wider text-[var(--primary-color)] px-3 py-1 bg-[var(--primary-color)]/10 rounded-full w-fit">
                    Açık Başvuru
                  </span>
                </div>
                <p className="text-sm text-gray-500 mt-4 leading-relaxed">
                  Şu an için spesifik bir açık pozisyonumuz bulunmasa da, ekibimizin bir parçası olmak isteyen tüm yetenekli adayların başvurularını değerlendirmekten memnuniyet duyarız. Özgeçmişinizi göndererek veri tabanımıza katılabilirsiniz.
                </p>
              </div>
            </div>
          </section>

          {/* Section 4: How to Apply */}
          <section className="space-y-6 bg-gray-50 p-8 rounded border border-gray-100">
            <h2 className="font-serif text-2xl font-light text-gray-900 tracking-wide">
              Başvuru Süreci
            </h2>
            <p className="text-sm">
              Mashow bünyesinde kariyer fırsatlarını değerlendirmek ve genel başvuru yapmak için güncel özgeçmişinizi (CV) ve varsa portfolyonuzu aşağıdaki e-posta adresimize gönderebilirsiniz. Başvurularınız insan kaynakları ekibimiz tarafından incelenecek ve profilinize uygun bir pozisyon oluşması durumunda sizinle iletişime geçilecektir.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4 pt-2">
              <div className="w-full text-center sm:text-left">
                <p className="text-xs text-gray-500 uppercase tracking-widest mb-1">E-posta Adresi</p>
                <a href="mailto:info@mashow.com.tr" className="text-lg font-normal text-gray-900 hover:text-[var(--primary-color)] transition">
                  info@mashow.com.tr
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Careers;
